module.exports = __webpack_public_path__ + "bg.15e1e34ef18f3f10abc8.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/images/bg.png
// module id = ../../../../../src/assets/images/bg.png
// module chunks = styles